module.exports = __webpack_public_path__ + "media/customizations/hylandtrail/logo-fe51dadd2a28391a390305f7349dbf23.png";